import React from 'react';
import classnames from 'classnames';
import {convertFileToContent} from './FileToContentConverter';
import Section from '../../Section';
import {getPropertyRightsDetails} from './Section8PropertyRightsDetails';
import {findFileByTypeId} from '../../../utils/files';
import styles from './styles.module.scss';

const fileTypeID = 1;

const getS8List = (context) => {
  const {cityName} = context.data.pdfData;

  return [
    ...getPropertyRightsDetails(context).map(item => (
      <div className={styles.innerPadding}>{item}</div>
    )),
    ...convertFileToContent(context, fileTypeID, {
      firstPageHeader: (
        <div className={classnames(styles.itemText, styles.bold, styles.innerPadding)}>
          עפ"י מידע עדכני מאת לשכת רישום המקרקעין {cityName}, להלן יובא
          מידע
          הרישום הרלוונטי:
        </div>
      ),
      lastPageFooter: (
        <Section
          customClassNames={{content: classnames(styles.itemText, styles.bold, styles.innerPadding)}}
        >
          חוו"ד זו אינה חוו"ד משפטית וכל האמור בסעיף זה הינו כרקע לחוו"ד
          בהתאם
          לממצאים המצויים בפני
          הח"מ במועד עריכת חוו"ד.
        </Section>
      ),
    })
  ];
};

const getS8File = (context, title) => {
  const {cityName} = context.data.pdfData;

  return convertFileToContent(context, fileTypeID, {
    firstPageHeader: (
      <Section
        title={title}
        customClassNames={{content: styles.noInnerPadding}}
      >
        <div className={classnames(styles.itemText, styles.bold)}>
          עפ"י מידע עדכני מאת לשכת רישום המקרקעין {cityName}, להלן יובא
          מידע
          הרישום הרלוונטי:
        </div>
      </Section>
    ),
    lastPageFooter: (
      <Section
        customClassNames={{content: classnames(styles.itemText, styles.bold)}}
      >
        חוו"ד זו אינה חוו"ד משפטית וכל האמור בסעיף זה הינו כרקע לחוו"ד
        בהתאם
        לממצאים המצויים בפני
        הח"מ במועד עריכת חוו"ד.
      </Section>
    ),
  });
};

const getS8Text = (context) => {
  return [
    ...getPropertyRightsDetails(context).map(item => (
      <div className={styles.innerPadding}>{item}</div>
    )),
    !context.data.pdfData.displayNoNesachText && (
      <div
        className={classnames(styles.itemText, styles.innerPadding, styles.bold, styles.lastSectionLine)}
      >
        במועד חוות הדעת לא ניתן היה להפיק נסח רישום עדכני והממצאים
        המפורטים בסעיף זה על פי המצוי בפני עורכ/ת
        חוות הדעת. במידה ויוצגו ממצאים שיש בהם לסתור את האמור לעיל, חוות
        הדעת תעודכן בהתאם לרלוונטיות.
      </div>
    )
  ];
};

export const getSection8 = (context) => {
  const file = findFileByTypeId(context.files, fileTypeID);
  const {propertyRightsDetails} = context.data.pdfData;

  if (file) {
    return (Boolean(propertyRightsDetails))
      ? getS8List(context)
      : getS8File(context);
  } else {
    return getS8Text(context);
  }
};
